import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { accountName, signOut } from '../auth/msal';
import { config } from '../config';

export function AppShell({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const name = accountName();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <AppBar position="sticky" color="primary">
        <Toolbar>
          <SupportAgentIcon sx={{ mr: 1 }} />
          <Typography
            variant="h6"
            sx={{ mr: 3, cursor: 'pointer' }}
            onClick={() => navigate('/tickets')}
          >
            IT Help
          </Typography>
          <Button
            color="inherit"
            size="small"
            startIcon={<ConfirmationNumberIcon />}
            onClick={() => navigate('/tickets')}
            sx={{ fontWeight: pathname.startsWith('/tickets') ? 700 : 400 }}
          >
            My tickets
          </Button>
          <Button
            color="inherit"
            size="small"
            startIcon={<MenuBookIcon />}
            onClick={() => navigate('/kb')}
            sx={{ fontWeight: pathname.startsWith('/kb') ? 700 : 400 }}
          >
            Knowledge base
          </Button>
          <Box sx={{ flexGrow: 1 }} />
          {config.helpdeskPhone && (
            <Button
              color="inherit"
              size="small"
              startIcon={<LocalPhoneIcon />}
              href={`tel:${config.helpdeskPhone.replace(/\s/g, '')}`}
              sx={{ mr: 1 }}
            >
              {config.helpdeskPhone}
            </Button>
          )}
          {name && (
            <Typography variant="body2" sx={{ mr: 2 }}>
              {name}
            </Typography>
          )}
          <Button color="inherit" size="small" onClick={() => signOut()}>
            Sign out
          </Button>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ py: 3 }}>
        {children}
      </Container>
    </Box>
  );
}
